import { render, staticRenderFns } from "./Office365Wizard.vue?vue&type=template&id=01afdde2&"
import script from "./Office365Wizard.vue?vue&type=script&lang=js&"
export * from "./Office365Wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports